var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-mb-4"},[_c('h2',{staticClass:"tw-capitalize uppercase tw-mb-3 tw-font-bold"},[_c('a',{attrs:{"href":'mailto:'+_vm.model.email}},[_vm._v(_vm._s(_vm.model.name))])]),_vm._v(" "),_c('div',{staticClass:"tw-flex tw-items-left"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.model.html)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }